import React from 'react';

import { useMutation } from '@apollo/client';
import { IDesignerBoard } from '@components/pages/DesignerProfile/graphql/designer-boards.graphql';
import { Modal } from 'react-bootstrap';
import { getResizedImageUrl } from '@lib/image';
import styles from './FeaturedBoardModal.module.scss';
import Arrow from './arrow.svg';
import FeatureDesignerBoardMutation from './featureDesignerBoard.graphql';

export interface IFeaturedBoardModalProps {
  close?: () => void;
  currentFeaturedBoard: IDesignerBoard;
  newFeaturedBoard: IDesignerBoard;
  isVisible? : boolean;
  onSuccess?: () => void;
}

export default function FeaturedBoardModal({
  close = () => {},
  currentFeaturedBoard,
  newFeaturedBoard,
  isVisible = false,
  onSuccess = () => {},
}: IFeaturedBoardModalProps) {
  const [featureDesignerBoard, { error }] = useMutation(
    FeatureDesignerBoardMutation,
    {
      onCompleted: () => {
        setTimeout(() => { onSuccess(); close(); }, 250);
      },
    },
  );

  return (
    <Modal
      show={isVisible}
      dialogClassName={styles.Dialog}
      contentClassName={styles.ContentContainer}
      centered
    >
      <div className={ styles.Title }>
        Replace your featured design
      </div>

      <div className={ styles.Hr } />

      <div className={ styles.Confirmation }>
        Are you sure you want to replace your featured design?
      </div>

      <div className={ styles.Subtext }>
        This design will be the first image in your profile portfolio.
      </div>

      <div className={ styles.Images }>
        <img
          alt="Previous Featured Board"
          className={ styles.Image }
          src={ getResizedImageUrl({
            height: Math.floor(160 * window.devicePixelRatio),
            quality: 90,
            url: getBoardImageUrl(currentFeaturedBoard),
          }) }
        />

        <span className={ styles.Arrow }>
          <Arrow />
        </span>

        <img
          alt="New Featured Board"
          className={ `${styles.Image} ${styles.hasBorder}` }
          src={ getResizedImageUrl({
            height: Math.floor(160 * window.devicePixelRatio),
            quality: 90,
            url: getBoardImageUrl(newFeaturedBoard),
          }) }
        />
      </div>

      { error && (
      <div className={ styles.Error }>
        {error.message}
      </div>
      )}

      <div className={ styles.Cta }>
        <button
          type="button"
          className={ `${styles.Button} ${styles.SecondaryButton}` }
          onClick={ close }
        >
          Cancel
        </button>

        <button
          type="button"
          className={ `${styles.Button} ${styles.PrimaryButton}` }
          onClick={ async () => {
            if (newFeaturedBoard && newFeaturedBoard.id) {
              await featureDesignerBoard({
                variables: {
                  boardId: newFeaturedBoard.id,
                },
              });
            }
          } }
        >
          Save new design
        </button>
      </div>
    </Modal>
  );
}

function getBoardImageUrl(board: IDesignerBoard) {
  return board.mainBoardAsset?.asset.url;
}
